export default class NetworkRequestFailedError extends Error {
  constructor() {
    super("Network request failed");
  }
}
